module.exports = __webpack_public_path__ + "static/media/BTCB-USDT.896711e6.svg";